import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useId } from 'react';

const Checkbox = ({ 
  label, 
  checked, 
  onChange, 
  disabled = false, 
  error = false,
  className = '',
  name = '',
  required = false,
  id = '',
}) => {
  const { t } = useTranslation();
  const checkboxId = useId();

  const handleChange = (e) => {
    onChange(e.target.checked);
  };

  return (
    <div className={`flex items-start ${className}`}>
      <div className="flex items-center h-5">
        <div className="relative">
          <input
            id={checkboxId}
            name={name}
            type="checkbox"
            checked={checked}
            onChange={handleChange}
            disabled={disabled}
            required={required}
            className={`
              appearance-none
              w-4 h-4 
              text-primary-600 
              bg-white 
              border-color-neutral-100
              border-2
              rounded-sm 
              shadow-sm 
              focus:outline-none 
              focus:ring-2 
              focus:ring-blue-500
              checked:border-neutral-50
              placeholder-neutral-400
              disabled:opacity-50
              disabled:cursor-not-allowed
              ${error ? 'border-red-500' : ''}
            `}
            aria-invalid={error}
            aria-describedby={error ? `${checkboxId}-error` : undefined}
          />
          {checked && (
            <svg
              className="absolute top-0 left-0 w-4 h-4 text-neutral-500 pointer-events-none"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          )}
        </div>
      </div>
      <div className="ml-2">
        <label
          htmlFor={checkboxId}
          className={`
            font-['Hero New']
            text-[18px] 
            leading-[20px] 
            ${disabled ? 'text-gray-400' : 'text-gray-700'}
            ${error ? 'text-red-500' : ''}
          `}
        >
          {label}
        </label>
        {error && (
          <p
            id={`${checkboxId}-error`}
            className="mt-1 text-sm text-red-500"
            role="alert"
          >
            {t('errors.required')}
          </p>
        )}
      </div>
    </div>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  id: PropTypes.string,
};

export default Checkbox; 
